import { FormGroup } from '@angular/forms';
import { DialogButton, DialogData } from '../../../store/models/dialog.model';
import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  Inject,
  InjectionToken,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { Subject } from 'rxjs';

export const DIALOG_COMPONENT = new InjectionToken<DialogComponent>(
  'DialogComponent',
);

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit, AfterViewInit {
  @ViewChild('content', { read: ViewContainerRef, static: true })
  content: ViewContainerRef;
  contentAsHtml = true;

  dialogForm: FormGroup;
  showTitleTooltip = false;
  component: any;

  result: any;

  onCloseEvent: Subject<any> = new Subject<any>();

  private triggerClose = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<DialogComponent>,
    private fr: ComponentFactoryResolver,
    private store: Store<IReducers>,
    private injector: Injector,
  ) {
  }

  close() {
    this.closeDialog();
  }

  onClose() {
    return this.onCloseEvent.asObservable();
  }

  closeDialog() {
    this.triggerClose = !!this.data.onClose;
    this.dialogRef.close();
  }

  onButtonClick(button: DialogButton) {
    if (button.actAsClose === true) {
      this.closeDialog();
    }

    if (button.onClick) {
      button.onClick(this);
    }
  }

  setResult(result: any): void {
    this.result = result;
  }

  onCloseButton() {
    if (this.data.onCloseButton) {
      this.data.onCloseButton(this);
    } else {
      this.closeDialog();
    }
  }

  setButtons(buttons: DialogButton[]) {
    this.data.buttons = buttons;
  }

  ngOnInit() {
    const cData: any = this.data.componentData;
    if (
      cData !== undefined &&
      cData.data !== undefined &&
      cData.data &&
      cData.data.tag !== undefined &&
      this.data.title !== 'Tips'
    ) {
      this.showTitleTooltip = true;
    }

    if (this.data.hideTitleTooltip) {
      this.showTitleTooltip = false;
    }
    this.dialogRef.afterClosed().subscribe(() => {
      if (this.data.onClose && this.triggerClose) {
        this.data.onClose(this);
      }
    });

    if (typeof this.data.content !== 'string') {
      this.contentAsHtml = false;
      const factory = this.fr.resolveComponentFactory(this.data.content as any);
      const injector = Injector.create({
        parent: this.injector,
        providers: [
          {
            provide: DIALOG_COMPONENT,
            useValue: this,
          },
        ],
      });
      const component = this.content.createComponent(factory, 0, injector);

      if (this.data.componentData) {
        for (const item in this.data.componentData) {
          if (this.data.componentData[item] !== undefined) {
            component.instance[item] = this.data.componentData[item];
          }
        }
      }

      this.dialogForm = new FormGroup({});
      // @ts-ignore
      component.instance.inputForm = this.dialogForm;
      // @ts-ignore
      component.instance.dialogRef = this;
      this.component = component.instance;
      component.changeDetectorRef.detectChanges();
    } else {
      this.contentAsHtml = true;
    }
  }

  ngAfterViewInit(): void {
  }

  openTooltip(type) {
    if (this.data.titleIcon) {
      return;
    }
    this.store.dispatch(openDialog({ dialogData: this.getDialogData(type) }));
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  getTitleIcon() {
    if (!this.data.titleIcon) {
      return 'Yellow Plane';
    }

    return this.data.titleIcon;
  }
}
